import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 5L5.90321 8.90321C5.95519 8.95519 6.04057 8.95131 6.08763 8.89485L8.41645 6.10026C8.462 6.0456 8.54392 6.03993 8.59657 6.08779L14 11M14 11V7M14 11H10"
      stroke="#EB5757"
      stroke-linecap="round"
    />
  </svg>
);
